import { FC, HTMLAttributes, ReactNode } from "react";
import { applyOpacityToHexColor } from "src/utility";

const Tag: FC<{ label: ReactNode; color: string; opacity?: string } & HTMLAttributes<HTMLDivElement>> = ({
  label,
  color,
  opacity,
  ...props
}) => {
  return (
    <div style={{ color, background: applyOpacityToHexColor(color, opacity) }} {...props}>
      {label}
    </div>
  );
};

export default Tag;
